// extracted by mini-css-extract-plugin
module.exports = {"resetButtonContainer":"User-tab_resetButtonContainer_2tKID"};